/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductStandardValuesQueryResponse,
  FindProductStandardValuesQueryParams,
} from "../types/FindProductStandardValues.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductStandardValuesQueryKey = (
  params?: FindProductStandardValuesQueryParams
) =>
  [
    { url: "/v1/product/find-product-standard-values" },
    ...(params ? [params] : []),
  ] as const

export type FindProductStandardValuesQueryKey = ReturnType<
  typeof findProductStandardValuesQueryKey
>

/**
 * @summary Find product standard values
 * {@link /v1/product/find-product-standard-values}
 */
export async function findProductStandardValues(
  params?: FindProductStandardValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductStandardValuesQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-product-standard-values`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductStandardValuesQueryOptions(
  params?: FindProductStandardValuesQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductStandardValuesQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductStandardValuesQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductStandardValuesQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductStandardValues(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find product standard values
 * {@link /v1/product/find-product-standard-values}
 */
export function useFindProductStandardValues<
  TData = ResponseConfig<FindProductStandardValuesQueryResponse>,
  TQueryData = ResponseConfig<FindProductStandardValuesQueryResponse>,
  TQueryKey extends QueryKey = FindProductStandardValuesQueryKey,
>(
  params?: FindProductStandardValuesQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductStandardValuesQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductStandardValuesQueryKey(params)

  const query = useQuery(
    {
      ...findProductStandardValuesQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
